(() => {
  'use strict';

  const PRODUCT_ORDER = ['lunar', 'bare', 'crystal', 'sweet', 'nebula', 'velvet'];

  const PRODUCTS = {
    lunar: {
      name: 'LunarMuse',
      positioning: 'Everyday',
      bestFor: 'everyday polish, office, clean makeup and first-time users',
      intensity: 2,
      beginnerFriendly: 5,
      role: 'A polished everyday first pick.',
      url: '/products/lashnova-lashnova-lunarmuse',
      specs: { length: '8-13mm', width: '23mm', curl: 'C-Curl / 50\u00B0' }
    },
    bare: {
      name: 'Bare Whisper',
      positioning: 'Most Natural',
      bestFor: 'minimal makeup, short natural lift and barely-there everyday looks',
      intensity: 1,
      beginnerFriendly: 5,
      role: 'The lightest and most natural match.',
      url: '/products/bare-whisper-soft-magnetic-lashes',
      specs: { length: '7-10mm', width: '21.5mm', curl: 'C-Curl / 50\u00B0' }
    },
    crystal: {
      name: 'Crystal Noir',
      positioning: 'Everyday: Balanced Definition',
      bestFor: 'balanced everyday definition, versatile eye shapes and polished daily wear',
      intensity: 3,
      beginnerFriendly: 4,
      role: 'A broad, versatile definition match.',
      url: '/products/crystal-noir-soft-magnetic-lashes',
      specs: { length: '10-12mm', width: '21.5mm', curl: 'C-Curl / 50\u00B0' }
    },
    sweet: {
      name: 'Sweet Glitz',
      positioning: 'Soft Glam: Doll-Eye',
      bestFor: 'doll-eye looks, cute soft glam, dates and playful makeup',
      intensity: 3,
      beginnerFriendly: 4,
      role: 'A center-focused sweet doll-eye match.',
      url: '/products/lashnova-sweetheart',
      specs: { length: '7-12mm', width: '23mm', curl: 'C-Curl / 50\u00B0' }
    },
    nebula: {
      name: 'Nebula Crown',
      positioning: 'Soft Glam: Camera-Ready',
      bestFor: 'polished looks, camera-ready makeup, photos, events and elevated daily wear',
      intensity: 4,
      beginnerFriendly: 3,
      role: 'The camera-ready and polished soft-glam match.',
      url: '/products/lashnova-queen-luxe',
      specs: { length: '10-13mm', width: '23mm', curl: 'C-Curl / 50\u00B0' }
    },
    velvet: {
      name: 'Velvet Bloom',
      positioning: 'Fuller Look',
      bestFor: 'bold glam, evenings, events, a fuller lash line and strong volume',
      intensity: 5,
      beginnerFriendly: 2,
      role: 'The boldest lifted-volume match.',
      url: '/products/velvet-bloom-soft-magnetic-lashes',
      specs: { length: '10-13.5mm', width: '22mm', curl: 'D-Curl / 65\u00B0' }
    }
  };

  const STEPS = [
    {
      id: 'lash_experience',
      name: 'Lash Experience',
      question: 'How familiar are you with lashes?',
      subtitle: 'Choose the answer that best reflects your current lash routine.',
      options: [
        { id: 'new', label: "I'm totally new to lashes", description: 'A supportive, easy starting point.', icon: '01', scores: [5, 5, 4, 4, 2, 1] },
        { id: 'hard', label: "I've tried, but lashes feel hard to apply", description: 'A simpler routine with easier alignment.', icon: '02', scores: [5, 5, 4, 4, 2, 0] },
        { id: 'easier', label: 'I can apply lashes, but want something easier', description: 'A cleaner, faster application routine.', icon: '03', scores: [4, 3, 4, 4, 3, 2] },
        { id: 'often', label: 'I wear lashes often', description: 'More freedom to choose a noticeable finish.', icon: '04', scores: [2, 1, 3, 4, 5, 6] }
      ]
    },
    {
      id: 'lash_look',
      name: 'Lash Look',
      question: 'What kind of lash look do you want?',
      subtitle: 'Choose the finish you would most like to see in the mirror.',
      options: [
        { id: 'minimal', label: 'Most Natural', description: 'The shortest, lightest-looking finish.', icon: 'N1', scores: [7, 12, 2, 1, 0, -4] },
        { id: 'soft', label: 'Everyday', description: 'Natural definition with a little more polish.', icon: 'N2', scores: [11, 5, 6, 5, 3, 0] },
        { id: 'doll', label: 'Soft Glam: Doll-Eye', description: 'Center-focused lift for a brighter, rounded look.', icon: 'N3', scores: [4, 1, 4, 12, 3, 2] },
        { id: 'defined', label: 'Everyday: Balanced Definition', description: 'Clean, versatile definition without heavy volume.', icon: 'N4', scores: [3, 1, 11, 4, 7, 4] },
        { id: 'photo', label: 'Soft Glam: Camera-Ready', description: 'More visible polish for photos, dinners and events.', icon: 'N5', scores: [2, 0, 7, 6, 11, 6] },
        { id: 'bold', label: 'Fuller Look', description: 'The fullest, most noticeable LashNova finish.', icon: 'N6', scores: [0, -4, 5, 6, 8, 13] }
      ]
    },
    {
      id: 'eye_shape',
      name: 'Eye Shape',
      question: "What's your eye shape?",
      subtitle: 'Choose the closest match, or select Not sure for a versatile recommendation.',
      layout: 'eyes',
      options: [
        { id: 'almond', label: 'Almond', description: 'Elongated with tapered inner and outer corners.', icon: 'AL', scores: [3, 3, 4, 3, 4, 4] },
        { id: 'round', label: 'Round', description: 'Open and circular with a visible upper and lower curve.', icon: 'RO', scores: [3, 2, 4, 1, 5, 5] },
        { id: 'hooded', label: 'Hooded', description: 'The eyelid slightly covers the crease.', icon: 'HO', scores: [6, 6, 5, 3, 2, -2] },
        { id: 'monolid', label: 'Monolid', description: 'Little to no visible crease.', icon: 'MO', scores: [5, 4, 6, 3, 4, 1] },
        { id: 'downturned', label: 'Downturned', description: 'The outer corners point slightly downward.', icon: 'DO', scores: [2, 2, 4, 3, 6, 6] },
        { id: 'upturned', label: 'Upturned', description: 'The outer corners lift slightly upward.', icon: 'UP', scores: [4, 3, 4, 4, 4, 4] },
        { id: 'unsure', label: 'Not sure', description: 'Choose this for a balanced, versatile match.', icon: '?', scores: [4, 3, 5, 3, 3, 2] }
      ]
    },
    {
      id: 'lifestyle',
      name: 'Lifestyle',
      question: 'Where will you wear your lashes most?',
      subtitle: 'Match your lash finish to the moments that matter most in your routine.',
      options: [
        { id: 'everyday', label: 'Everyday / Work', description: 'Polished wear for regular routines.', icon: 'WK', scores: [9, 8, 7, 4, 3, -2] },
        { id: 'dates', label: 'Dates / Nights Out', description: 'A little more presence for evenings.', icon: 'PM', scores: [5, 2, 6, 8, 6, 4] },
        { id: 'travel', label: 'Vacations / Travel', description: 'Flexible, easy styling away from home.', icon: 'TR', scores: [8, 8, 6, 4, 4, 0] },
        { id: 'events', label: 'Special Events / Photos', description: 'A more visible finish for cameras and occasions.', icon: 'EV', scores: [2, -2, 6, 7, 9, 10] }
      ]
    },
    {
      id: 'top_priority',
      name: 'Top Priority',
      question: 'What matters most to you in a lash?',
      subtitle: 'Choose the single quality you want the recommendation to prioritize.',
      options: [
        { id: 'comfort', label: 'All-Day Comfort', description: 'A lightweight-feeling choice for longer wear.', icon: 'C', scores: [9, 9, 6, 4, 3, 1] },
        { id: 'easy', label: 'Easy Application', description: 'A more approachable everyday routine.', icon: 'E', scores: [9, 9, 7, 5, 4, 2] },
        { id: 'natural', label: 'Natural Look', description: 'A soft finish that enhances without taking over.', icon: 'N', scores: [9, 10, 5, 3, 1, -4] },
        { id: 'glam', label: 'Glam Look', description: 'More visible fullness and beauty presence.', icon: 'G', scores: [2, -3, 6, 7, 9, 10] },
        { id: 'reliable', label: 'Secure, Reusable Wear', description: 'Secure wear with a reusable lash routine.', icon: 'R', scores: [5, 5, 5, 4, 4, 4] }
      ]
    }
  ];

  const TIE_ORDERS = {
    minimal: ['bare', 'lunar', 'crystal', 'sweet', 'nebula', 'velvet'],
    soft: ['lunar', 'crystal', 'bare', 'sweet', 'nebula', 'velvet'],
    doll: ['sweet', 'crystal', 'lunar', 'nebula', 'bare', 'velvet'],
    defined: ['crystal', 'nebula', 'lunar', 'sweet', 'bare', 'velvet'],
    photo: ['nebula', 'crystal', 'velvet', 'sweet', 'lunar', 'bare'],
    bold: ['velvet', 'nebula', 'sweet', 'crystal', 'lunar', 'bare']
  };

  const MATCH_TAG_SLUGS = Object.freeze({
    lunar: 'lunarmuse',
    bare: 'bare-whisper',
    crystal: 'crystal-noir',
    sweet: 'sweet-glitz',
    nebula: 'nebula-crown',
    velvet: 'velvet-bloom'
  });
  const CUSTOMER_TAG_BASE = ['newsletter', 'lash-finder'];
  const CUSTOMER_TAG_PREFIXES = ['experience', 'look', 'eye', 'lifestyle', 'priority'];
  const COMPLETE_CUSTOMER_TAG_COUNT = CUSTOMER_TAG_BASE.length + CUSTOMER_TAG_PREFIXES.length + 1;

  const toKebabCase = (value) => {
    if (value === null || value === undefined) return '';
    return String(value)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };
  const createCustomerTag = (prefix, value) => {
    const safePrefix = toKebabCase(prefix);
    const safeValue = toKebabCase(value);
    return safePrefix && safeValue ? `${safePrefix}-${safeValue}` : '';
  };
  const normalizeCustomerTags = (value) => {
    const values = Array.isArray(value) ? value : String(value || '').split(',');
    return [...new Set(values.map(toKebabCase).filter(Boolean))];
  };
  const getOption = (stepIndex, optionId) => STEPS[stepIndex].options.find((option) => option.id === optionId);
  const buildCustomerTags = (topKey, answers) => {
    const matchSlug = MATCH_TAG_SLUGS[topKey];
    if (!matchSlug || !Array.isArray(answers) || answers.length !== STEPS.length) return [];
    const answerTags = STEPS.map((_, index) => {
      const selected = getOption(index, answers[index]);
      return selected ? createCustomerTag(CUSTOMER_TAG_PREFIXES[index], selected.id) : '';
    });
    const tags = normalizeCustomerTags([
      ...CUSTOMER_TAG_BASE,
      createCustomerTag('match', matchSlug),
      ...answerTags
    ]);
    return tags.length === COMPLETE_CUSTOMER_TAG_COUNT ? tags : [];
  };
  const hasCompleteCustomerTags = (value) => {
    const tags = normalizeCustomerTags(value);
    if (tags.length !== COMPLETE_CUSTOMER_TAG_COUNT || !CUSTOMER_TAG_BASE.every((tag) => tags.includes(tag))) return false;
    const allowedMatchTags = new Set(Object.values(MATCH_TAG_SLUGS).map((slug) => createCustomerTag('match', slug)));
    if (tags.filter((tag) => allowedMatchTags.has(tag)).length !== 1) return false;
    return CUSTOMER_TAG_PREFIXES.every((prefix, index) => {
      const allowedAnswerTags = new Set(STEPS[index].options.map((option) => createCustomerTag(prefix, option.id)));
      return tags.filter((tag) => allowedAnswerTags.has(tag)).length === 1;
    });
  };

  const calculateResult = (answers) => {
    const scores = Object.fromEntries(PRODUCT_ORDER.map((key) => [key, 0]));

    STEPS.forEach((step, stepIndex) => {
      const selected = step.options.find((option) => option.id === answers[stepIndex]);
      if (!selected) return;
      PRODUCT_ORDER.forEach((productKey, productIndex) => {
        scores[productKey] += selected.scores[productIndex];
      });
    });

    const tieOrder = TIE_ORDERS[answers[1]] || TIE_ORDERS.soft;
    const tieIndex = Object.fromEntries(tieOrder.map((key, index) => [key, index]));
    const ranked = PRODUCT_ORDER.slice().sort((left, right) => {
      const scoreDifference = scores[right] - scores[left];
      return scoreDifference || tieIndex[left] - tieIndex[right];
    });

    return {
      best: ranked[0],
      ranked,
      alternatives: ranked.slice(1, 3),
      scores,
      topScore: scores[ranked[0]],
      secondScore: scores[ranked[1]],
      scoreGap: scores[ranked[0]] - scores[ranked[1]],
      tieOrder: tieOrder.slice()
    };
  };

  const matchLabel = (scoreGap) => {
    if (scoreGap >= 7) return 'Strong Match';
    if (scoreGap >= 3) return 'Best Match';
    return 'Close Match';
  };

  const explanationFor = (answers) => {
    const experienceClauses = {
      new: 'You wanted a confident first lash choice',
      hard: 'You wanted a more approachable application routine',
      easier: 'You wanted a cleaner, faster application routine',
      often: 'You are comfortable with a more noticeable lash finish'
    };
    const lookClauses = {
      minimal: 'preferred the most natural finish',
      soft: 'wanted polished everyday definition',
      doll: 'chose a brighter, center-focused soft glam look',
      defined: 'wanted balanced everyday definition without excessive volume',
      photo: 'wanted camera-ready soft glam for photos and events',
      bold: 'wanted a fuller look with stronger beauty presence'
    };
    const lifestyleSentences = {
      everyday: 'Your match is suitable for regular work and everyday routines.',
      dates: 'Your match carries enough presence for dates and nights out.',
      travel: 'Your match supports an easy, versatile travel routine.',
      events: 'Your match is designed to hold more visual presence for events and photos.'
    };
    const eye = getOption(2, answers[2]);
    const priority = getOption(4, answers[4]);
    const firstSentence = `${experienceClauses[answers[0]] || 'You shared your lash experience'} and ${lookClauses[answers[1]] || 'chose your preferred finish'}.`;
    const secondSentence = lifestyleSentences[answers[3]] || 'Your routine helped shape the recommendation.';
    const thirdSentence = eye?.id === 'unsure'
      ? `Keeping eye shape flexible and focusing on ${priority?.label.toLowerCase() || 'your top priority'} refined the ranking.`
      : `Your ${eye?.label || 'eye-shape'} selection and focus on ${priority?.label.toLowerCase() || 'your top priority'} refined the ranking.`;
    return `${firstSentence} ${secondSentence} ${thirdSentence}`;
  };

  const alternativeLabelCandidates = (topKey, alternativeKey) => {
    const top = PRODUCTS[topKey];
    const alternative = PRODUCTS[alternativeKey];
    const candidates = [];

    if (alternative.beginnerFriendly > top.beginnerFriendly) candidates.push('More Wearable Alternative');
    if (alternative.intensity < top.intensity) candidates.push('More Natural Alternative');
    if (alternativeKey === 'nebula' && topKey !== 'nebula') candidates.push('Camera-Ready Alternative');
    if (alternative.intensity > top.intensity) candidates.push('Bolder Alternative');
    candidates.push('Another Great Match');
    return [...new Set(candidates)];
  };

  const labelAlternatives = (topKey, alternativeKeys) => {
    const used = new Set();
    return alternativeKeys.map((key) => {
      const candidates = alternativeLabelCandidates(topKey, key);
      const label = candidates.find((candidate) => !used.has(candidate)) || 'Another Great Match';
      used.add(label);
      return { key, label };
    });
  };

  const answersFromCustomerTags = (value) => {
    const tags = normalizeCustomerTags(value);
    if (!hasCompleteCustomerTags(tags)) return null;
    const answers = CUSTOMER_TAG_PREFIXES.map((prefix, index) => {
      const choice = STEPS[index].options.find((option) => tags.includes(createCustomerTag(prefix, option.id)));
      return choice?.id;
    });
    if (!answers.every((answer, index) => getOption(index, answer))) return null;
    const expected = buildCustomerTags(calculateResult(answers).best, answers);
    return expected.length === tags.length && expected.every((tag) => tags.includes(tag)) ? answers : null;
  };
  const validStoredAnswers = (snapshot, sectionId, now = Date.now()) => {
    if (!snapshot || snapshot.version !== 1 || snapshot.sectionId !== sectionId || snapshot.complete !== true || snapshot.pending !== true) return null;
    if (!Number.isFinite(snapshot.savedAt) || snapshot.savedAt > now + 300000 || now - snapshot.savedAt > 86400000) return null;
    if (!Array.isArray(snapshot.answers) || snapshot.answers.length !== STEPS.length) return null;
    if (!snapshot.answers.every((answer, index) => typeof answer === 'string' && getOption(index, answer))) return null;
    return snapshot.answers.slice();
  };

  const model = {
    PRODUCT_ORDER,
    PRODUCTS,
    STEPS,
    TIE_ORDERS,
    calculateResult,
    matchLabel,
    explanationFor,
    labelAlternatives,
    MATCH_TAG_SLUGS,
    CUSTOMER_TAG_PREFIXES,
    toKebabCase,
    buildCustomerTags,
    hasCompleteCustomerTags,
    answersFromCustomerTags,
    validStoredAnswers
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = model;
  if (typeof document === 'undefined') return;

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const initRoot = (root) => {
    if (!root || root.dataset.lnfInitialized === 'true') return;
    const products = Object.fromEntries(PRODUCT_ORDER.map((key) => [key, {
      ...PRODUCTS[key],
      name: root.dataset[`${key}Title`] || PRODUCTS[key].name,
      present: root.dataset[`${key}Present`] === 'true',
      available: root.dataset[`${key}Available`] === 'true',
      url: root.dataset[`${key}Url`] || root.dataset.collectionUrl || '',
      image: root.dataset[`${key}ImageUrl`] || '',
      imageWidth: Number(root.dataset[`${key}ImageWidth`]) || 0,
      imageHeight: Number(root.dataset[`${key}ImageHeight`]) || 0
    }]));
    const eyeShapeAssets = {
      almond: root.dataset.eyeAlmondUrl,
      round: root.dataset.eyeRoundUrl,
      hooded: root.dataset.eyeHoodedUrl,
      monolid: root.dataset.eyeMonolidUrl,
      downturned: root.dataset.eyeDownturnedUrl,
      upturned: root.dataset.eyeUpturnedUrl,
      unsure: root.dataset.eyeNotSureUrl
    };

    const stage = root.querySelector('[data-lnf-stage]');
    const topbar = root.querySelector('[data-lnf-topbar]');
    const backButton = root.querySelector('[data-lnf-back]');
    const progressLabel = root.querySelector('[data-lnf-progress-label]');
    const progress = root.querySelector('[data-lnf-progress]');
    const profileContent = root.querySelector('[data-lnf-profile-content]');
    const profileMessage = root.querySelector('[data-lnf-profile-message] p');
    const status = root.querySelector('[data-lnf-status]');
    const specStrip = root.querySelector('[data-lnf-spec-strip]');
    const savePanel = root.querySelector('[data-lnf-save-panel]');
    const resultActions = root.querySelector('[data-lnf-result-actions]');
    const signupForm = root.querySelector('form.lnf-save-form-shell');
    const recoveryPanel = root.querySelector('[data-lnf-recovery-panel]');
    const clientError = signupForm?.querySelector('[data-lnf-client-error]');
    const emailInput = signupForm?.querySelector('input[type="email"]');
    const serverMessage = signupForm?.querySelector('[data-ln-form-result]');
    let copy = {};
    try { copy = JSON.parse(root.querySelector('[data-lnf-copy]')?.textContent || '{}'); } catch (_error) {}
    const text = (key, values = {}) => String(copy[key] || '').replace(/__(\w+)__|{{\s*(\w+)\s*}}/g, (_match, token, brace) => String(values[token || brace] ?? ''));
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)') || { matches: false };
    const state = { screen: 'intro', step: 0, answers: Array(STEPS.length).fill(null), result: null };
    const customerTagsStorageKey = `lashnova-finder-tags:${root.dataset.sectionId || 'main'}`;
    const sectionId = root.dataset.sectionId || 'main';
    const answersStorageKey = `lashnova-finder-answers:v1:${sectionId}`;
    const hasServerFormResponse = Boolean(serverMessage);
    const isOwnFormResponse = hasServerFormResponse && window.location.hash === `#${signupForm?.id}`;
    let recoveryNeeded = false;
    let savedDescription = emailInput?.getAttribute('aria-describedby') || '';
    if (serverMessage?.id) savedDescription = savedDescription.split(/\s+/).filter((id) => id !== serverMessage.id).join(' ');
    if (!stage || !topbar || !backButton || !progressLabel || !progress || !profileContent || !profileMessage || !status || !specStrip) return;
    root.dataset.lnfInitialized = 'true';
    let finderRun = 0;
    let advanceTimer = null;
    let renderVersion = 0;

    const trackFinder = (name, data = {}, onceKey = '') => {
      try {
        const analytics = window.LashNovaAnalytics;
        if (!analytics?.track) return;
        const payload = {
          surface: 'ai_lash_finder',
          finder_section: root.dataset.sectionId || 'main',
          ...data,
        };
        if (onceKey && analytics.trackOnce) analytics.trackOnce(name, payload, onceKey);
        else analytics.track(name, payload);
      } catch (_error) {
        // Analytics must never interrupt the Finder experience.
      }
    };

    const selectedAnswer = (stepIndex) => getOption(stepIndex, state.answers[stepIndex]);
    const customerTagsField = () => signupForm?.querySelector('[data-lnf-customer-tags]');
    const readStoredCustomerTags = () => {
      try {
        return normalizeCustomerTags(window.sessionStorage.getItem(customerTagsStorageKey));
      } catch (error) {
        return [];
      }
    };
    const storeCustomerTags = (tags) => {
      try {
        window.sessionStorage.setItem(customerTagsStorageKey, tags.join(','));
      } catch (error) {
        // The submitted hidden field remains authoritative when storage is unavailable.
      }
    };
    const storeAnswers = (pending = false) => {
      if (!state.result || !state.answers.every((answer, index) => getOption(index, answer))) return;
      try {
        window.sessionStorage.setItem(answersStorageKey, JSON.stringify({ version: 1, sectionId, complete: true, pending, answers: state.answers.slice(), savedAt: Date.now() }));
      } catch (_error) {}
    };
    const readAnswers = () => {
      let snapshot;
      try {
        snapshot = window.sessionStorage.getItem(answersStorageKey);
      } catch (_error) {
        return answersFromCustomerTags(customerTagsField()?.value);
      }
      if (snapshot !== null) {
        try { return validStoredAnswers(JSON.parse(snapshot), sectionId); } catch (_error) { return null; }
      }
      return answersFromCustomerTags(customerTagsField()?.value) || answersFromCustomerTags(readStoredCustomerTags());
    };
    const clearCustomerTags = () => {
      const field = customerTagsField();
      if (field) field.value = CUSTOMER_TAG_BASE.join(',');
      try {
        window.sessionStorage.removeItem(customerTagsStorageKey);
        window.sessionStorage.removeItem(answersStorageKey);
      } catch (_error) {}
    };
    const applyCustomerTags = (value) => {
      const tags = normalizeCustomerTags(value);
      const field = customerTagsField();
      if (!field || !answersFromCustomerTags(tags)) return false;
      field.value = tags.join(',');
      storeCustomerTags(tags);
      return true;
    };
    const syncCustomerTags = (pending = false) => {
      storeAnswers(pending);
      return applyCustomerTags(buildCustomerTags(state.result?.best, state.answers));
    };
    const customerTagsForSubmission = () => state.screen === 'result' && state.result
      ? buildCustomerTags(state.result.best, state.answers) : [];
    const clearFeedback = () => {
      if (serverMessage) serverMessage.hidden = true;
      if (clientError) { clientError.hidden = true; clientError.textContent = ''; }
      emailInput?.removeAttribute('aria-invalid');
      if (emailInput) emailInput.setAttribute('aria-describedby', savedDescription);
    };
    const focusFormFeedback = () => {
      window.requestAnimationFrame(() => {
        const target = serverMessage && !serverMessage.hidden ? serverMessage : recoveryPanel && !recoveryPanel.hidden ? recoveryPanel : null;
        target?.focus();
      });
    };
    const showRecovery = (submit = false) => {
      recoveryNeeded = true;
      if (recoveryPanel) recoveryPanel.hidden = false;
      if (savePanel) savePanel.hidden = false;
      if (submit && clientError) {
        clientError.textContent = text('recovery_submit');
        clientError.hidden = false;
        clientError.id = `LashFinderClientError-${sectionId}`;
        if (emailInput) emailInput.setAttribute('aria-describedby', [savedDescription, clientError.id].filter(Boolean).join(' '));
        clientError.focus();
      }
    };
    const cancelAdvance = () => {
      if (advanceTimer !== null) window.clearTimeout(advanceTimer);
      advanceTimer = null;
    };
    const sectionWrapper = root.closest('.shopify-section') || root;
    sectionWrapper.addEventListener('shopify:section:unload', () => {
      cancelAdvance();
      renderVersion += 1;
    });
    const focusHeading = () => {
      stage.querySelector('h1')?.focus({ preventScroll: true });
    };
    const hasActiveOverlay = () => {
      const focusContainer = typeof trapFocusHandlers === 'undefined' ? null : trapFocusHandlers.container;
      if (focusContainer?.isConnected && !root.contains(focusContainer)) return true;
      return Boolean(document.querySelector(
        'header-drawer > details[open], menu-drawer > details[open], details-modal > details[open], ' +
        'cart-drawer.active, cart-notification .cart-notification.active, ' +
        'modal-dialog[open], product-modal[open], quick-add-modal[open], dialog[open], [role="dialog"][open]'
      ));
    };
    const scrollToFinder = () => {
      const stickyHeader = document.querySelector('sticky-header');
      const headerHeight = stickyHeader?.getBoundingClientRect().height || 0;
      const top = Math.max(0, window.scrollY + stage.getBoundingClientRect().top - headerHeight - 16);
      window.scrollTo({ top, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };
    const eyeIllustrationMarkup = (id) => {
      const imageUrl = eyeShapeAssets[id];
      if (!imageUrl) return `<span class="lnf-option-icon" aria-hidden="true">${escapeHtml(getOption(2, id)?.icon || '?')}</span>`;
      return `<span class="lnf-eye-illustration lnf-eye-illustration--${escapeHtml(id)}" aria-hidden="true"><img src="${escapeHtml(imageUrl)}" alt="" loading="lazy" decoding="async"></span>`;
    };
    const productMediaMarkup = (product) => {
      if (!product.image) return '';
      const dimensions = product.imageWidth > 0 && product.imageHeight > 0 ? ` width="${product.imageWidth}" height="${product.imageHeight}"` : '';
      return `<figure class="lnf-product-media"><img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}"${dimensions} loading="lazy" decoding="async"></figure>`;
    };
    const keySpecsMarkup = (product) => `
      <dl class="lnf-key-specs">
        <div><dt>Lash Length</dt><dd>${escapeHtml(product.specs.length)}</dd></div>
        <div><dt>Fit Width</dt><dd>${escapeHtml(product.specs.width)}</dd></div>
        <div><dt>Curl</dt><dd>${escapeHtml(product.specs.curl)}</dd></div>
        <div><dt>Positioning</dt><dd>${escapeHtml(product.positioning)}</dd></div>
      </dl>`;
    const LOOK_PRODUCTS = { minimal: 'bare', soft: 'lunar', doll: 'sweet', defined: 'crystal', photo: 'nebula', bold: 'velvet' };
    const displayAlternativeLabel = (label) => {
      const keys = { 'More Wearable Alternative': 'another_style', 'More Natural Alternative': 'more_natural', 'Camera-Ready Alternative': 'camera_ready', 'Bolder Alternative': 'bolder', 'Another Great Match': 'another_style' };
      return text(keys[label] || 'another_style');
    };
    const stockMarkup = (product) => product.available && product.present ? ''
      : `<p class="lnf-stock-status">${escapeHtml(text(product.present ? 'currently_unavailable' : 'product_missing'))}</p>`;
    const resultReason = () => text('result_reason', {
      look: selectedAnswer(1)?.label || '', routine: selectedAnswer(3)?.label || '', priority: selectedAnswer(4)?.label || ''
    });
    const tradeoffMarkup = (result) => {
      const requestedKey = LOOK_PRODUCTS[state.answers[1]];
      if (!requestedKey || result.best === requestedKey) return '';
      const bestIndex = PRODUCT_ORDER.indexOf(result.best);
      const requestedIndex = PRODUCT_ORDER.indexOf(requestedKey);
      const factors = STEPS.map((step, index) => ({ label: selectedAnswer(index).label, delta: selectedAnswer(index).scores[bestIndex] - selectedAnswer(index).scores[requestedIndex], index }))
        .filter((factor) => factor.index !== 1 && factor.delta > 0).sort((left, right) => right.delta - left.delta).slice(0, 2).map((factor) => factor.label);
      const requested = products[requestedKey];
      const comparison = result.ranked.slice(0, 3).includes(requestedKey) ? ''
        : `<a class="lnf-style-comparison" href="${escapeHtml(requested.present ? requested.url : root.dataset.collectionUrl)}" data-lnf-product="${escapeHtml(requestedKey)}">${escapeHtml(text('compare_requested', { product: requested.name }))}</a>`;
      return `<div class="lnf-tradeoff"><p>${escapeHtml(text('tradeoff', { look: selectedAnswer(1).label, requested: requested.name, factors: factors.join(text('and_separator')), product: products[result.best].name }))}</p>${comparison}</div>`;
    };

    const introMarkup = () => `
      <div class="lnf-intro lnf-stage-enter">
        <p class="lnf-eyebrow"><span aria-hidden="true">&#10022;</span> AI Lash Finder</p>
        <h1 tabindex="-1">Find Your Lash <span>Match</span></h1>
        <p class="lnf-lede">Answer five quick questions about the lash look you want, eye shape, routine and top priority. All six styles use the same simple application system.</p>
        <div class="lnf-intro-actions">
          <button class="lnf-button lnf-button--primary" type="button" data-lnf-start>Start My Lash Finder <span aria-hidden="true">&rarr;</span></button>
          <span class="lnf-trust-pill">30 seconds &middot; Six styles &middot; No photo needed</span>
        </div>
        <ul class="lnf-chip-list" role="list"><li>No glue or liner</li><li>One simple application system</li><li>Lightweight soft magnetic feel</li></ul>
      </div>`;

    const questionMarkup = (stepIndex) => {
      const step = STEPS[stepIndex];
      const eyeClass = step.layout === 'eyes' ? ' lnf-options--eyes' : '';
      const titleId = `lnf-question-${root.dataset.sectionId || 'main'}-${stepIndex}`;
      const hintId = `${titleId}-hint`;
      const hasSelection = Boolean(state.answers[stepIndex]);
      return `
        <div class="lnf-question lnf-question--step-${stepIndex + 1} lnf-stage-enter">
          <p class="lnf-eyebrow"><span aria-hidden="true">&#10022;</span> ${escapeHtml(step.name)}</p>
          <h1 id="${escapeHtml(titleId)}" tabindex="-1">${escapeHtml(step.question)}</h1>
          <p>${escapeHtml(step.subtitle)}</p>
          <p class="lnf-selection-hint" id="${escapeHtml(hintId)}">${escapeHtml(root.dataset.lnfSelectionHint)}</p>
          <div class="lnf-options${eyeClass}" role="radiogroup" aria-labelledby="${escapeHtml(titleId)}" aria-describedby="${escapeHtml(hintId)}">
            ${step.options.map((option, optionIndex) => {
              const selected = state.answers[stepIndex] === option.id;
              const tabIndex = selected || (!hasSelection && optionIndex === 0) ? 0 : -1;
              return `
                <button class="lnf-option${step.layout === 'eyes' ? ` lnf-eye-card lnf-eye-card--${escapeHtml(option.id)}` : ''}${selected ? ' is-selected' : ''}" type="button" role="radio" aria-checked="${selected}" tabindex="${tabIndex}" data-lnf-option="${escapeHtml(option.id)}">
                  ${step.layout === 'eyes' ? eyeIllustrationMarkup(option.id) : `<span class="lnf-option-icon" aria-hidden="true">${escapeHtml(option.icon)}</span>`}
                  <span class="lnf-option-copy"><strong>${escapeHtml(option.label)}</strong><span>${escapeHtml(option.description)}</span></span>
                  <span class="lnf-option-radio" aria-hidden="true"></span>
                </button>`;
            }).join('')}
          </div>
          <div class="lnf-question-actions">
            <button class="lnf-button lnf-button--primary lnf-continue" type="button" data-lnf-continue${hasSelection ? '' : ' disabled'}>${escapeHtml(stepIndex === STEPS.length - 1 ? root.dataset.lnfShowMatchLabel : root.dataset.lnfContinueLabel)} <span aria-hidden="true">&rarr;</span></button>
          </div>
        </div>`;
    };

    const resultMarkup = () => {
      const result = state.result || calculateResult(state.answers);
      const best = products[result.best];
      const alternatives = labelAlternatives(result.best, result.alternatives);
      const hasBestImage = Boolean(best.image);
      return `
        <div class="lnf-result lnf-stage-enter">
          <div class="lnf-result-heading">
            <p class="lnf-eyebrow"><span aria-hidden="true">&#10022;</span> Match Complete</p>
            <h1 tabindex="-1">Your Personalized Match</h1>
            <p>All five answers shaped this guided LashNova recommendation.</p>
          </div>
          <article class="lnf-match-card${hasBestImage ? '' : ' lnf-match-card--text'}">
            <div class="lnf-match-copy">
              <span class="lnf-top-match">${escapeHtml(matchLabel(result.scoreGap))} &middot; Top Match</span>
              <h2>${escapeHtml(best.name)}</h2>
              <strong>${escapeHtml(best.positioning)}</strong>
              <p class="lnf-result-explanation">${escapeHtml(resultReason())}</p>
              <p class="lnf-best-for"><strong>Best for:</strong> ${escapeHtml(best.bestFor)}.</p>
              ${tradeoffMarkup(result)}
              <p class="lnf-match-note">${escapeHtml(text('match_note'))}</p>
              ${stockMarkup(best)}
              ${keySpecsMarkup(best)}
              <a class="lnf-button lnf-button--primary" href="${escapeHtml(best.url)}" data-lnf-product="${escapeHtml(result.best)}">${escapeHtml(text(!best.present ? 'shop_styles' : best.available ? 'shop_match' : 'view_style_details'))}</a>
            </div>
            ${productMediaMarkup(best)}
          </article>
          <div class="lnf-alternatives-wrap">
            <div class="lnf-section-mini-heading"><h2>Two relevant alternatives</h2><p>The next highest scores from the same five answers.</p></div>
            <div class="lnf-alternatives">
              ${alternatives.map(({ key, label }) => {
                const product = products[key];
                const hasImage = Boolean(product.image);
                return `<a class="lnf-alt-card${hasImage ? '' : ' lnf-alt-card--text'}" href="${escapeHtml(product.url)}" data-lnf-product="${escapeHtml(key)}">
                  ${productMediaMarkup(product)}
                  <div class="lnf-alt-copy"><span class="lnf-alt-label">${escapeHtml(displayAlternativeLabel(label))}</span><h3>${escapeHtml(product.name)}</h3><span>${escapeHtml(product.positioning)}</span>${stockMarkup(product)}<span class="lnf-view">${escapeHtml(text(product.present ? 'explore_style' : 'shop_styles'))} &rarr;</span></div>
                </a>`;
              }).join('')}
            </div>
          </div>
        </div>`;
    };

    const renderProgress = () => {
      if (state.screen === 'intro') {
        topbar.hidden = true;
        return;
      }
      topbar.hidden = false;
      const completeCount = state.screen === 'result' ? STEPS.length : state.step;
      const currentValue = state.screen === 'result' ? STEPS.length : state.step + 1;
      progressLabel.textContent = state.screen === 'result' ? 'Match Complete' : `Step ${state.step + 1} / ${STEPS.length}`;
      progress.setAttribute('aria-valuenow', String(currentValue));
      progress.setAttribute('aria-valuetext', state.screen === 'result' ? 'All five steps complete' : `Step ${state.step + 1} of ${STEPS.length}`);
      progress.innerHTML = STEPS.map((_, index) => `<span class="${index < completeCount || state.screen === 'result' ? 'is-complete' : ''}"></span>`).join('');
    };

    const profileRows = () => {
      if (state.screen === 'intro') {
        return [
          ['Lash Experience', 'Matched to your comfort level'],
          ['Lash Look', 'Matched to your preferred finish'],
          ['Daily Routine', 'Matched to real-life wear']
        ].map(([name, copy], index) => `
          <div class="lnf-profile-row"><span class="lnf-profile-index">${index + 1}</span><span class="lnf-profile-copy"><strong>${name}</strong><span>${copy}</span></span></div>`).join('');
      }

      return STEPS.map((step, index) => {
        const selected = selectedAnswer(index);
        const isComplete = Boolean(selected);
        const isCurrent = state.screen === 'step' && index === state.step;
        const className = isComplete ? 'is-complete' : isCurrent ? 'is-current' : 'is-pending';
        const marker = isComplete ? '&#10003;' : index + 1;
        const copy = selected ? selected.label : isCurrent ? 'In progress' : 'Waiting for your choice';
        return `<div class="lnf-profile-row ${className}"><span class="lnf-profile-index">${marker}</span><span class="lnf-profile-copy"><strong>${escapeHtml(step.name)}</strong><span>${escapeHtml(copy)}</span></span></div>`;
      }).join('');
    };

    const updateProfile = () => {
      profileContent.innerHTML = profileRows();
      if (state.screen === 'intro') {
        status.innerHTML = '<span aria-hidden="true">&#10022;</span> Guided Match';
        profileMessage.textContent = 'Your best LashNova match is five answers away.';
      } else if (state.screen === 'result') {
        const best = products[state.result.best];
        status.innerHTML = `<span aria-hidden="true">&#10022;</span> ${escapeHtml(matchLabel(state.result.scoreGap))}`;
        profileMessage.textContent = `${best.name} leads the ranking after all five answers.`;
      } else {
        status.innerHTML = '<span aria-hidden="true">&#10022;</span> Building Match';
        const remaining = STEPS.length - state.step - 1;
        profileMessage.textContent = remaining > 0
          ? `${remaining} more ${remaining === 1 ? 'answer' : 'answers'} will complete your match.`
          : 'This final answer completes your personalized LashNova match.';
      }
    };

    const render = ({ focus = true, scroll = true } = {}) => {
      cancelAdvance();
      const version = ++renderVersion;
      if (savePanel) savePanel.hidden = state.screen !== 'result' && !recoveryNeeded;
      if (resultActions) resultActions.hidden = state.screen !== 'result';
      stage.innerHTML = state.screen === 'intro' ? introMarkup() : state.screen === 'result' ? resultMarkup() : questionMarkup(state.step);
      specStrip.hidden = state.screen === 'result';
      renderProgress();
      updateProfile();
      window.requestAnimationFrame(() => {
        if (version !== renderVersion || !root.isConnected) return;
        if (hasActiveOverlay()) return;
        if (focus) focusHeading();
        if (scroll && state.screen !== 'intro') scrollToFinder();
      });
    };

    const selectedAnswersDetail = () => Object.fromEntries(STEPS.map((step, index) => [step.id, state.answers[index]]));
    const dispatchResultEvent = () => {
      const topProduct = products[state.result.best];
      const secondKey = state.result.ranked[1];
      const secondProduct = products[secondKey];
      const selectedAnswers = selectedAnswersDetail();
      window.dispatchEvent(new CustomEvent('lashnova:finder-result', {
        detail: {
          selected_answers: selectedAnswers,
          top_product: topProduct.name,
          top_score: state.result.topScore,
          second_product: secondProduct.name,
          score_gap: state.result.scoreGap
        }
      }));
      const resultPayload = {
        top_product: topProduct.name,
        top_product_key: state.result.best,
        top_score: state.result.topScore,
        second_product: secondProduct.name,
        score_gap: state.result.scoreGap,
        selected_answers: selectedAnswers,
      };
      trackFinder(
        'ln_finder_complete',
        resultPayload,
        `finder-complete:${root.dataset.sectionId || 'main'}:${finderRun}`
      );
      trackFinder(
        'ln_finder_result_view',
        resultPayload,
        `finder-result-view:${root.dataset.sectionId || 'main'}:${finderRun}`
      );
    };

    const startFinder = () => {
      finderRun += 1;
      clearFeedback();
      recoveryNeeded = false;
      if (recoveryPanel) recoveryPanel.hidden = true;
      state.screen = 'step';
      state.step = 0;
      state.answers = Array(STEPS.length).fill(null);
      state.result = null;
      clearCustomerTags();
      trackFinder('ln_finder_start', { question_count: STEPS.length, finder_run: finderRun });
      render();
    };

    const advance = () => {
      cancelAdvance();
      if (!root.isConnected || state.screen !== 'step' || !selectedAnswer(state.step)) return;
      const completedStep = STEPS[state.step];
      const completedAnswer = selectedAnswer(state.step);
      if (completedStep && completedAnswer) {
        trackFinder('ln_finder_step_complete', {
          finder_run: finderRun,
          step_index: state.step + 1,
          step_id: completedStep.id,
          answer_id: completedAnswer.id,
        });
      }
      if (state.step === STEPS.length - 1) {
        state.result = calculateResult(state.answers);
        state.screen = 'result';
        syncCustomerTags();
        dispatchResultEvent();
      } else {
        state.step += 1;
      }
      render();
    };

    const selectOption = (optionButton, { autoAdvance = false } = {}) => {
      if (!optionButton || state.screen !== 'step') return;
      const selected = getOption(state.step, optionButton.dataset.lnfOption);
      if (!selected) return;
      cancelAdvance();
      state.answers[state.step] = selected.id;
      root.querySelectorAll('[data-lnf-option]').forEach((button) => {
        const active = button === optionButton;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-checked', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      const continueButton = root.querySelector('[data-lnf-continue]');
      if (continueButton) continueButton.disabled = false;
      updateProfile();
      if (autoAdvance) advanceTimer = window.setTimeout(advance, 540);
    };

    root.addEventListener('click', (event) => {
      const start = event.target.closest('[data-lnf-start]');
      if (start) {
        startFinder();
        return;
      }

      const optionButton = event.target.closest('[data-lnf-option]');
      if (optionButton) {
        selectOption(optionButton, { autoAdvance: event.detail > 0 });
        return;
      }

      const continueButton = event.target.closest('[data-lnf-continue]');
      if (continueButton && !continueButton.disabled) {
        advance();
        return;
      }

      const retake = event.target.closest('[data-lnf-retake]');
      if (retake) {
        trackFinder('ln_finder_retake', {
          finder_run: finderRun,
          from_screen: state.screen,
        });
        clearFeedback();
        recoveryNeeded = false;
        if (recoveryPanel) recoveryPanel.hidden = true;
        state.screen = 'intro';
        state.step = 0;
        state.answers = Array(STEPS.length).fill(null);
        state.result = null;
        clearCustomerTags();
        render();
        return;
      }

      const productLink = event.target.closest('[data-lnf-product]');
      if (productLink && state.result) {
        const productKey = productLink.dataset.lnfProduct;
        const rank = state.result.ranked.indexOf(productKey) + 1;
        trackFinder('ln_finder_result_click', {
          finder_run: finderRun,
          product_key: productKey,
          product_title: products[productKey]?.name,
          result_rank: rank > 0 ? rank : undefined,
          destination_path: products[productKey]?.url,
        });
      }

    });

    root.addEventListener('keydown', (event) => {
      const actionButton = event.target.closest('[data-lnf-start], [data-lnf-retake]');
      if (actionButton && (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')) {
        event.preventDefault();
        actionButton.click();
        return;
      }
      const optionButton = event.target.closest('[data-lnf-option]');
      if (!optionButton) return;
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        selectOption(optionButton);
        advance();
        return;
      }
      if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      const buttons = Array.from(root.querySelectorAll('[data-lnf-option]'));
      const currentIndex = buttons.indexOf(optionButton);
      if (currentIndex < 0) return;
      event.preventDefault();
      let nextIndex = currentIndex;
      if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = buttons.length - 1;
      else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
      else nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      buttons[nextIndex].focus();
      selectOption(buttons[nextIndex]);
    });

    if (isOwnFormResponse) {
      const answers = readAnswers();
      if (answers) {
        state.answers = answers;
        state.result = calculateResult(answers);
        state.screen = 'result';
        syncCustomerTags(true);
        render({ focus: false, scroll: false });
      } else {
        showRecovery();
      }
      focusFormFeedback();
    } else if (hasServerFormResponse) {
      clearFeedback();
      if (savePanel) savePanel.hidden = true;
    }
    emailInput?.addEventListener('input', clearFeedback);
    if (signupForm && signupForm.dataset.lnfTagsBound !== 'true') {
      signupForm.dataset.lnfTagsBound = 'true';
      signupForm.addEventListener('submit', (event) => {
        if (!applyCustomerTags(customerTagsForSubmission())) {
          event.preventDefault();
          showRecovery(true);
          trackFinder('ln_finder_email_error', {
            finder_run: finderRun,
            error_code: 'incomplete_finder_state',
          });
          return;
        }
        clearFeedback();
        storeAnswers(true);
        trackFinder('ln_finder_email_submit', {
          finder_run: finderRun,
          top_product: state.result ? products[state.result.best]?.name : undefined,
        });
      });
    }

    const goBack = () => {
      if (state.screen === 'result') {
        state.screen = 'step';
        state.step = STEPS.length - 1;
      } else if (state.screen === 'step' && state.step > 0) {
        state.step -= 1;
      } else {
        state.screen = 'intro';
      }
      render();
    };

    backButton.addEventListener('click', goBack);
    backButton.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      event.preventDefault();
      goBack();
    });

    if (!isOwnFormResponse || state.screen !== 'result') updateProfile();
  };

  const initWithin = (scope) => {
    const roots = [];
    if (scope?.matches?.('[data-lnf-root]')) roots.push(scope);
    scope?.querySelectorAll?.('[data-lnf-root]').forEach((root) => roots.push(root));
    roots.forEach(initRoot);
  };

  initWithin(document);
  if (!window.__lashNovaFinderSectionListenerBound) {
    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
    window.__lashNovaFinderSectionListenerBound = true;
  }
})();
